import { modalMessages } from "./api_services_maps";

export default function SETCOORDS() {
    let addressesObj = $.ajax({
        type: "POST",
        url: $("#allAddressRouteGet").val(),
        data: "",
        dataType: "json",
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
        }
    }).done(() => {
        const allAddress = addressesObj.responseJSON;

        let allCoords = []
        let geocoder;
        let platform = new H.service.Platform({
            'apikey': 'PVjG2C87NWztpCHBTpVmR7MP2Cfka35bfohUx7igBnY'
            // 'apikey': 'QEYPoO3xSNcfZayZbpLwO9JjJU5_id9rgrmM7QogASw'
        });

        let setAllCoords = () => {

            const ALL_ADDRESS = allAddress;
            const promises = Array.from(ALL_ADDRESS).map((address) => {
                //caso o endereço já tenha latitude e longitude
                if (address.lat && address.lng) {
                    allCoords.push(address);
                } else {
                    return findCoords(address.address).then((storesCoords) => {
                        if (storesCoords != undefined) {
                            const data = {
                                ...address,
                                lat: storesCoords.lat,
                                lng: storesCoords.lng,
                            };

                            allCoords.push(data);
                            addCoordsToDB(data);
                            return true;
                        }
                    }).catch((error) => {
                        console.error('Error:', error);
                        modalMessages(
                            'Algum erro aconteceu, estamos tentando indentifica-lo...',
                            'Ops !'
                        );
                        return true;
                    });
                }
            });

            return new Promise((resolve, reject) => {
                Promise.all(promises)
                    .then(() => {

                        resolve(true);
                    })
                    .catch((error) => {
                        console.error('Error:', error);
                        modalMessages(
                            'Algum erro aconteceu, estamos tentando indentifica-lo...',
                            'Ops !'
                        );
                        return true;
                    });
            });
        };

        function findCoords(address) {
            let addressNumbers = address.replace(/[^\d]/g, "");
            let addressClean = address.replace(/[\s]/g, "");
            if (addressClean.length < 10 && addressNumbers.length == 8) {
                address = addressNumbers;
                const parte1 = address.slice(0,5);
                const parte2 = address.slice(5,8);
                address = parte1 + '-' + parte2 + ' BR';
            }
            return new Promise((resolve, reject) => {
                let geocodingParams = {
                    searchText: address,
                    q: address,
                };

                let onResult = function (result) {
                    try {
                        let locations = result.items[0].position
                        const position = {
                            lat: locations.lat,
                            lng: locations.lng
                        };

                        resolve(position);
                        return position;

                    } catch (error) {
                        // modalMessages('Algum erro aconteceu ao solicitar a localização de uma de nossas unidades, estamos tentando resolve-lo...', 'Ops !')
                        resolve(undefined);
                        return undefined
                    }
                };

                geocoder = platform.getSearchService();

                geocoder.geocode(geocodingParams, onResult, function (e) {
                    reject(() => {
                        alert('error')
                    });
                });
            });
        }

        function setCoordsUSER_COMPANY(pos) {
            const promise = async () => {
                return setAllCoords()
                    .then((result) => {
                        const jsonResult = allCoords
                    })
                    .catch((error) => {
                        alert(error)
                    });
            };

            promise();
        }

        function addCoordsToDB(data) {
            let dataForm = 'cardData=' + JSON.stringify(data);
            // '&' causa um comportamento inesperado ao enviar os dados
            dataForm = dataForm.replace(/&/g, "EEE");
            $.ajax({
                type: "post",
                url: $("#allAddressRouteSet").val(),
                data: dataForm,
                dataType: "json",
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
                },
            });
        }

        setCoordsUSER_COMPANY()
    });
}